import { render, staticRenderFns } from "./C-1-3__CategoryEdit.vue?vue&type=template&id=656b534e&"
import script from "./C-1-3__CategoryEdit.vue?vue&type=script&lang=js&"
export * from "./C-1-3__CategoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./C-1-3__CategoryEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VSpacer,VTextField,VTextarea})
